import { render } from "./ValidationStrategy.vue?vue&type=template&id=356dd1ef&scoped=true"
import script from "./ValidationStrategy.vue?vue&type=script&lang=js"
export * from "./ValidationStrategy.vue?vue&type=script&lang=js"

import "./ValidationStrategy.vue?vue&type=style&index=0&id=356dd1ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356dd1ef"]])

export default __exports__